import { cx } from '@emotion/css';
import { IconLookup, IconName } from '@fortawesome/fontawesome-svg-core';
import { useLocation } from 'react-router-dom';

import { Icon, Link } from 'apps/shared/scripts/components';

import {
  activeClassName,
  activeIconClassName,
  iconClassName,
  labelClassName,
  sidenavItemClassName,
} from './styles';

interface Props {
  faIcon: IconLookup | IconName;
  label: string;
  hideMenu: () => void;
  to: string;
}

const SidenavItem = ({ faIcon, label, hideMenu, to }: Props) => {
  const { pathname } = useLocation();

  const isActive = pathname.includes(to);

  return (
    <Link
      className={cx(sidenavItemClassName, { [activeClassName]: isActive })}
      onClick={hideMenu}
      to={to}
    >
      <Icon
        className={cx(iconClassName, { [activeIconClassName]: isActive })}
        fa={faIcon}
      />
      <span className={labelClassName}>{label}</span>
    </Link>
  );
};

SidenavItem.displayName = 'SidenavItem';

export default SidenavItem;
